import type { MessengerFormField } from '@widgets/messenger/types'
import { computed } from '@/composition/vue/compositionApi'

type FieldMap<Names extends string> = Record<Names, MessengerFormField<Names> & { order: number }>

export const useFormFieldMap = <
  Names extends string,
  T extends MessengerFormField<Names>[] = MessengerFormField<Names>[],
>(
  formFieldsGetter: () => T,
) => {
  const fieldMap = computed(() =>
    formFieldsGetter().reduce((map, field, index) => {
      map[field.name] = {
        ...field,
        order: index + 1,
      }
      return map
    }, {} as FieldMap<Names>),
  )

  return {
    fieldMap,
  }
}
